/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { BaseCustomerV1Dto } from './BaseCustomerV1Dto';
import type { BasePartnerV1Dto } from './BasePartnerV1Dto';
import type { CustomerBankingAccountV1Dto } from './CustomerBankingAccountV1Dto';
import type { PartnerBankingAccountV1Dto } from './PartnerBankingAccountV1Dto';
export type PaymentV1Dto = {
  /**
   * The unique identifier of the entity.
   */
  readonly id: string;
  /**
   * The date when the entity was created.
   */
  readonly createdAt: string;
  /**
   * The date when the entity was modified.
   */
  readonly modifiedAt: string;
  /**
   * The current version of the entity
   */
  version: number;
  /**
   * Amount in currency format with up to 2 decimal places (max 13 digits before decimal)
   */
  amount: number;
  /**
   * the vat rate in percent of the payment with up to 2 decimal places
   */
  vatRate: number;
  /**
   * The currency of the payment.
   */
  currency: PaymentV1Dto.currency;
  /**
   * Reference of payment as part of the bank transfer
   */
  reference?: string | null;
  /**
   * Description date of the payment. Not part of the bank transfer.
   */
  description?: string | null;
  /**
   * Flag if the payment is recurring
   */
  isRecurring: boolean;
  /**
   * date of payment or start date of recurring payments
   */
  startDate?: string;
  /**
   * The end date of the recurring payment
   */
  endDate?: string | null;
  /**
   * The interval of the recurring payment in months
   */
  interval?: number;
  /**
   * The reference date of the recurring payment
   */
  dayOfMonth?: number;
  /**
   * Flag index-clause payment. If true calculationStartDate and lastAdjustment mus be set
   */
  isIndexPayment: boolean;
  /**
   * Start date calculation
   */
  calculationStartDate?: string;
  /**
   * Last adjustment date
   */
  lastAdjustment?: string;
  /**
   * the type of the payment
   */
  paymentType: PaymentV1Dto.paymentType;
  /**
   * The unique identifier of the contract linked to this relation.
   */
  contractId: string;
  /**
   * The linked customer.
   */
  customer: BaseCustomerV1Dto;
  /**
   * The linked customer-banking-account.
   */
  customerBankingAccount: CustomerBankingAccountV1Dto;
  /**
   * The linked partner.
   */
  partner: BasePartnerV1Dto;
  /**
   * The linked partner-banking-account.
   */
  partnerBankingAccount: PartnerBankingAccountV1Dto;
};
export namespace PaymentV1Dto {
  /**
   * The currency of the payment.
   */
  export enum currency {
    EUR = 'EUR',
    ALL = 'ALL',
    AMD = 'AMD',
    AZN = 'AZN',
    BYN = 'BYN',
    BAM = 'BAM',
    CZK = 'CZK',
    DKK = 'DKK',
    GEL = 'GEL',
    GIP = 'GIP',
    GGP = 'GGP',
    HUF = 'HUF',
    ISK = 'ISK',
    IMP = 'IMP',
    JEP = 'JEP',
    KZT = 'KZT',
    CHF = 'CHF',
    MDL = 'MDL',
    MKD = 'MKD',
    NOK = 'NOK',
    PLN = 'PLN',
    RON = 'RON',
    RUB = 'RUB',
    RSD = 'RSD',
    SEK = 'SEK',
    TRY = 'TRY',
    UAH = 'UAH',
    GBP = 'GBP',
  }
  /**
   * the type of the payment
   */
  export enum paymentType {
    BASE_RENT = 'BaseRent',
    MINIMUM_RENT = 'MinimumRent',
    TURNOVER_BASED_RENT = 'TurnoverBasedRent',
    TURNOVER_BASED_RENT_ADVANCE_PAYMENT = 'TurnoverBasedRentAdvancePayment',
    ADDITIONAL_COST_ADVANCE_PAYMENT = 'AdditionalCostAdvancePayment',
    ADDITIONAL_COST_FLAT_RATE = 'AdditionalCostFlatRate',
    ADVERTISING_COSTS = 'AdvertisingCosts',
    HEATING_COST_ADVANCE_PAYMENT = 'HeatingCostAdvancePayment',
    ADMINISTRATIVE_COSTS = 'AdministrativeCosts',
    CENTER_MANAGEMENT = 'CenterManagement',
    PARKING_SPACE_RENTAL = 'ParkingSpaceRental',
    GROUND_RENT = 'GroundRent',
    OTHER = 'Other',
  }
}
